import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e86156c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lblTitle" }, "Welcome to Sales Note Circulation System"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" On this page, you can issue, confirm, and circulate the electronic Sales Note."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" The Sales Note data will be sent from SMC to overseas distributors through SCAN system."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" You can also receive the notice by e-mail, when the Sales Note data is processed."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ])
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createVNode($setup["SalesNoteHeaderNavigation"]),
    _createVNode($setup["SalesNoteLinkNavigation"]),
    _hoisted_2
  ]))
}